var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52315",
    "data-name": "Group 52315",
    transform: "translate(-0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50538",
    "data-name": "Group 50538"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_468",
    "data-name": "Ellipse 468",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(0.15)",
    fill: "#007acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "info",
    d: "M94.35,55.461c-.589.067-1.762.233-2.357.266a1.73,1.73,0,0,1-1.27-.448.778.778,0,0,1-.188-.962l2.345-4.369H90.442c0-.91,1.006-1.58,2.294-1.837a12.932,12.932,0,0,1,2.357-.265,2.268,2.268,0,0,1,1.27.448.778.778,0,0,1,.188.962l-2.345,4.369h2.437C96.644,54.536,95.674,55.312,94.35,55.461Zm.744-8.139c-.856,0-1.55-.47-1.55-1.051s.694-1.051,1.55-1.051,1.55.47,1.55,1.051S95.95,47.323,95.094,47.323Z",
    transform: "translate(-83.647 -40.382)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueInfoIcon);
export default __webpack_public_path__ + "static/media/blue_info_icon.8f8dda6aec0ca39a3d9ea271ffc951ad.svg";
export { ForwardRef as ReactComponent };